
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CustomButton',

  props: {
    /**
   * Size of the button. Can be 'large' or 'small'.
   */
    size: { type: String, default: 'large' },

    /**
   * Variant of the button. Can be 'primary', 'secondary', 'text', 'icon', 'link'.
   */
    variant: { type: String, default: 'primary' },

    fullWidth: { type: Boolean, default: false },
    dataTest: { type: String, default: '' },
    label: { type: String, default: 'OK' },
    type: { type: String, default: 'button' },
  },

  computed: {
    classList() {
      const variantClass = `button-${this.variant}`;
      const sizeClass = `button-${this.size}`;
      const width = this.fullWidth ? 'full-width' : '';
      return [variantClass, sizeClass, width];
    },

    dataTestAttr(): string {
      if (this.dataTest) return this.dataTest;
      return `${this.label.split(' ')[0].toLocaleLowerCase()}Btn`;
    },
  },
});
